import React, { createContext, useContext, useState } from "react";

export const INITIAL_ADDON_QUANTITY = 1;

interface IActiveAddonContext {
  activeAddonId: string | null;
  activeAddonQuantity: number;
  setActiveAddonId: (id: string | null) => void;
  setActiveAddonQuantity: (quantity: number) => void;
}

const ActiveAddonContext = createContext<IActiveAddonContext>({
  activeAddonId: null,
  activeAddonQuantity: INITIAL_ADDON_QUANTITY,
  setActiveAddonId: () => null,
  setActiveAddonQuantity: () => undefined,
});

export const useActiveAddon = (): IActiveAddonContext => useContext(ActiveAddonContext);

export const ActiveAddonProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [activeAddonId, setActiveAddonId] = useState<string | null>(null);
  const [activeAddonQuantity, setActiveAddonQuantity] = useState<number>(INITIAL_ADDON_QUANTITY);

  return (
    <ActiveAddonContext.Provider
      value={{ activeAddonId, setActiveAddonId, activeAddonQuantity, setActiveAddonQuantity }}
    >
      {children}
    </ActiveAddonContext.Provider>
  );
};
